declare global {
  interface Window {
    ZENDESK_KEY?: string
  }
}

export function initZenDesk(): void {
  if (!window.ZENDESK_KEY) {
    // eslint-disable-next-line no-console
    console.warn('[ZenDesk] ZENDESK_KEY not set, skipping init')
    return
  }

  const script = document.createElement('script')
  script.id = 'ze-snippet'
  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${window.ZENDESK_KEY}`
  document.head.appendChild(script)
  // eslint-disable-next-line no-console
  console.info('[ZenDesk] Widget script injected')
}
